import firebase from 'firebase'
import { Board as IBoard } from 'minimax_ttt';
import { firestore } from './firebase'

export type IRoom = {
  id: string
  roomName: string
  roomOwnerId: string
  startByRoomOwner: boolean
}

export type Document = { board: IBoard } & { createdAt: firebase.firestore.Timestamp }

export class BoardObservable {
  public getBoards(roomId: string, onSnapshots: (docs: Document[]) => any) {
    firestore.collection('room').doc(roomId).collection('boards').orderBy('createdAt', 'asc').onSnapshot((snapshot) => {
      const docs: Document[] = []
      snapshot.docs.forEach(doc => {
        const data: Document = doc.data() as any
        if (data.createdAt) {
          docs.push(doc.data() as any)
        }
      })
      if (docs.length > 0) {
        onSnapshots(docs)
      }
    })
  }
}
